import { type AuditBackgroundForm } from '../audit-background-form/audit-background-form';

import { type FormIssue } from '.';

export function reviewBackgroundForm(
  form: AuditBackgroundForm | null,
): FormIssue[] {
  const issues: FormIssue[] = [];

  if (!form?.general.buildingName) {
    issues.push({ field: 'Building Name', message: 'Required' });
  }

  if (!form?.general.yearBuilt) {
    issues.push({ field: 'Construction Year', message: 'Required' });
  }

  return issues;
}
